class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');
    this.onViewportChange = this.syncViewportVars.bind(this);

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    this.querySelector('button[type="button"]').addEventListener('click', this.close.bind(this));

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.target.closest('details').hasAttribute('open') ? this.close() : this.open(event);
  }

  onBodyClick(event) {
    if (!this.contains(event.target) || event.target.classList.contains('modal-overlay')) this.close(false);
  }

  syncViewportVars() {
    const vv = window.visualViewport;
    const height = vv ? vv.height : window.innerHeight;
    const offset = vv ? vv.offsetTop : 0;
    document.documentElement.style.setProperty('--search-vv-height', `${Math.round(height)}px`);
    document.documentElement.style.setProperty('--search-vv-offset', `${Math.round(offset)}px`);

    const field = this.querySelector('.search__input, .field__input');
    if (field) {
      const bottom = field.getBoundingClientRect().bottom - (vv ? vv.offsetTop : 0);
      document.documentElement.style.setProperty('--search-field-bottom', `${Math.max(0, Math.round(bottom))}px`);
    }
  }

  bindViewport() {
    this.syncViewportVars();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.onViewportChange);
      window.visualViewport.addEventListener('scroll', this.onViewportChange);
    }
    window.addEventListener('resize', this.onViewportChange);
  }

  unbindViewport() {
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.onViewportChange);
      window.visualViewport.removeEventListener('scroll', this.onViewportChange);
    }
    window.removeEventListener('resize', this.onViewportChange);
    document.documentElement.style.removeProperty('--search-vv-height');
    document.documentElement.style.removeProperty('--search-vv-offset');
    document.documentElement.style.removeProperty('--search-field-bottom');
  }

  open(event) {
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    event.target.closest('details').setAttribute('open', true);
    document.body.addEventListener('click', this.onBodyClickEvent);
    document.body.classList.add('overflow-hidden');
    this.bindViewport();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );
  }

  close(focusToggle = true) {
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    this.unbindViewport();
  }
}

customElements.define('details-modal', DetailsModal);
